<template>
    <div>
        <CategoryList />

        <v-tabs class="mobile-tabs-categories" vertical show-arrows color=" " v-model="gameTabs" @change="SetCateGame()">
            <v-tab class="d-flex flex-column" v-for="(n, index) in getGameDataDetail" :key="getGameCateCurrent + '_' + index"
                background-color="grey lighten-2"  color="grey--text text--darken-1">
                <img  class="mb-2" width="50" height="50" v-lazy="getGameImageAsset(index)" alt="" @error="setNoImage($event)"/>
                <div class=" mb-0 text-11 text-capitalize text-truncate d-inline-block mw-70 text-white">{{ setGameName(index) }}
                </div>
            </v-tab>
            <v-tab-item v-for="(n, index) in getGameDataDetail" :key="getGameCateCurrent + '_' + index">
                <v-card flat>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <h5 class="font-600  text-white mb-4 ">{{ setGameName(index) }}
                                    <!-- <v-btn depressed color="primary" @click="setGameDefault()">
                                        Primary {{ gameTabs }} {{ getGameCateListCurrent }}
                                    </v-btn> -->
                                </h5>
                                <v-row>
                                    <v-col :cols="checkCateColumn(n_game)" v-for="(n_game, index_name) in n" :key="getGameCateCurrent + '_' + index + '_' + index_name" class="p-2 ">
                                        <div class="card-game-show" :class="allowCate(n_game) == true ? 'none-width' : ''">

                                            <div class="text-center  text-decoration-none  " @click="goToGame(n_game)">
                                                <div v-if="allowCate(n_game) == true">
                                                    <img width="100%" v-lazy="n_game.IMAGE != null && n_game.IMAGE != '' ? n_game.IMAGE : n_game.CASINOIMG" alt="" @error="setNoImage($event)">
                                                </div>
                                                <div v-if="allowCate(n_game) == false">
                                                    <v-avatar size="80" tile>
                                                        <img v-lazy="n_game.IMAGE" alt="" @error="setNoImage($event)">
                                                    </v-avatar>
                                                </div>
                                                
                                                
                                                <div>
                                                    <p
                                                        class="text-11 text-capitalize text-truncate d-inline-block mw-70 text-white ">
                                                        {{ n_game.NAME }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-tab-item>
        </v-tabs>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import MobileNavigation from '@/layouts/base/MobileNavigationBar'
import AppBar from '../layouts/base/AppBar.vue';
import CategoryList from "@/components/CategoryList.vue" 
import Loading from "@/components/Loading.vue" 
import MobileNavigationBar from '../layouts/base/MobileNavigationBar.vue';
export default {

    components: {
        MobileNavigation,
        MobileNavigationBar,
        AppBar,
        CategoryList,
        Loading
    },
    computed: {
        ...mapGetters(['getGameCategoryList', 'getGameDataDetail', 'getIsLoadingProgress', 'getGameCateListCurrent', 'getGameCateCurrent', 'getIsLogin', 'getGameCateCurrent']),
    },
    watch: {
        "getGameCateListCurrent": function (val) {
            
            // console.log('MobileCategories.vue watch -> getGameCateListCurrent', this.getGameDataDetail)
            // console.log('MobileCategories.vue watch -> getGameCateListCurrent', val)
        }
    },
    data() {
        return {
            gameTabs: 0,
            configAllow12Cols: ['Sport', 'Live-Casino']
        }
    },
    mounted() {
        // console.log('MobileCategories.vue mounted -> getGameDataDetail',this.getGameDataDetail, this.getGameCateListCurrent)
        if (this.getGameCateListCurrent != null) {      
            let pos = Object.keys(this.getGameDataDetail).findIndex(key => key == this.getGameCateListCurrent)
            if (pos != -1) {
                this.gameTabs = pos
            }
        }
        // this.$router.params.GAME_CATEGORY_ID
        if (this.$route.params.hasOwnProperty('GAME_CATEGORY_ID')) {
            // console.log('MobileCategories.vue mounted -> GAME_CATEGORY_ID', this.$route.params.GAME_CATEGORY_ID)
            this.GetGamePage({GAME_CATEGORY_ID: this.$route.params.GAME_CATEGORY_ID})
        }
    },  
    methods: {
        ...mapActions(['GetGamePage', 'JoinGame', 'setGameCateListCurrent','setModalLogin']),
        setGameName(index) {
            let name = index
            if (index.toLowerCase().indexOf('pgsoft') != -1) name = 'PGSoft'
            else if (index.toLowerCase().indexOf('pragmatic') != -1) name = 'PragmaticPlay'
            return name
        },
        allowCate(itemData = null) {
            let isAllow = false
            if (itemData != null) {
                if (this.configAllow12Cols.indexOf(itemData.CATEGORY) != -1) {
                    isAllow = true
                }
            }
            // console.log('MobileCategories.vue -> allowCate -> isAllow', isAllow)
            return isAllow
        },
        checkCateColumn(itemData = null) {
            let cols = 4
            if (itemData != null) {
                if (this.configAllow12Cols.indexOf(itemData.CATEGORY) != -1) {
                    cols = 12
                }
            }
            // console.log('MobileCategories.vue -> checkCateColumn -> cols', cols)
            return cols
        },
        SetCateGame() {
            // this.setGameCateListCurrent(this.gameTabs)
            // console.log('MobileCategories.vue -> SetCateGame -> gameTabs', this.gameTabs)
        },
        setGameDefault() {
            // console.log(JSON.stringify(this.getGameDataDetail, null, 2))
        },
        async goToGame(item) {
            if (!this.getIsLogin) {
                this.setModalLogin(true)
                return
            }
            // console.log('MobileCategories.vue -> goToGame -> itemDataGame', JSON.stringify(item, null, 2), href)
            let PROVIDER,
                NAME,
                MOREDES,
                MOREDES_h,
                MOREDES_w,
                MOREDES_GAMETYPEID,
                MOREDES_TYPEDES,
                MOREDES_TECHNOLOGY,
                MOREDES_PLATFORM,
                href,
                game_url
                if( item.MOREDES !== undefined && item.MOREDES || item.CATEGORY == 'Sport') {
                    PROVIDER    =   (item.PROVIDER !== undefined ? item.PROVIDER.toLowerCase() : ``)
                    NAME        =   (item.NAME !== undefined ? item.NAME.replace(`'`,`\\'`) : ``)
                    MOREDES     =   item.MOREDES !== undefined && item.MOREDES ? JSON.parse(item.MOREDES) : {
                        h: 0,
                        w: 0,
                        GAMETYPEID: 0,
                        TYPEDES: '',
                        TECHNOLOGY: '',
                        PLATFORM: ''
                    }
                    MOREDES_h   =   (MOREDES.h !== undefined ? `&h=${MOREDES.h}` : ``);
                    MOREDES_w   =   (MOREDES.w !== undefined ? `&w=${MOREDES.w}` : ``);

                    MOREDES_GAMETYPEID =   (MOREDES.GAMETYPEID !== undefined ? `&GAMETYPEID=${MOREDES.GAMETYPEID}` : ``);
                    MOREDES_TYPEDES    =   (MOREDES.TYPEDES    !== undefined ? `&TYPEDES=${MOREDES.TYPEDES}`       : ``);
                    MOREDES_TECHNOLOGY =   (MOREDES.TECHNOLOGY !== undefined ? `&TECHNOLOGY=${MOREDES.TECHNOLOGY}` : ``);
                    MOREDES_PLATFORM   =   (MOREDES.PLATFORM   !== undefined ? `&PLATFORM=${MOREDES.PLATFORM}`     : ``);
                   

                    // if( nameGroup.toLowerCase() === "agslot" )
                    // {
                    //     // if( is_mobile() === false )
                    //     // {
                    //     //     game_url =  `${baseURL}/games/client/${item.CATEGORY}/${PROVIDER}`
                    //     //     href     =  `javascript:windowPopup('${nameGroup}-${NAME}','${game_url}?enterGame=true&gtype=${item.CATEGORY}&Gamename=${NAME}&GameId=${item.ID}&imgurl=${item.IMAGE + MOREDES_h + MOREDES_w + MOREDES_GAMETYPEID + MOREDES_TYPEDES + MOREDES_TECHNOLOGY + MOREDES_PLATFORM}');`
                    //     // }
                    //     // else
                    //     // {
                    //         href     =  `${baseURL}/games/client/${item.CATEGORY}/${PROVIDER}?enterGame=true&gtype=${item.CATEGORY}&Gamename=${NAME}&GameId=${item.ID}&imgurl=${item.IMAGE + MOREDES_h + MOREDES_w + MOREDES_GAMETYPEID + MOREDES_TYPEDES + MOREDES_TECHNOLOGY + MOREDES_PLATFORM}`;
                    //         target   =  "target='_blank'";
                    //     // }
                    // }
                    // else
                    // {
                        href    =   `/${item.CATEGORY}/${PROVIDER}?enterGame=true&gtype=${item.CATEGORY}&Gamename=${item.NAME}&GameId=${item.ID}&imgurl=${item.IMAGE + MOREDES_h + MOREDES_w + MOREDES_GAMETYPEID + MOREDES_TYPEDES + MOREDES_TECHNOLOGY + MOREDES_PLATFORM}`
                    // }
                    let resJoinGame = await this.JoinGame(href);
                    if (typeof resJoinGame == 'object' && resJoinGame.hasOwnProperty('Status')) {
                        if (resJoinGame.Status == 'SUCCESS') {
                            // href blank 
                            window.open(resJoinGame.Data.gameurl, '_blank');
                            // this.$router.push({ name: "Play Games", params: { dataGameJoin: resJoinGame.Data } });
                        }
                    }
                    // console.log('MobileCategories.vue -> goToGame -> resJoinGame', resJoinGame)
                } else {
                    if (item.CATEGORY == 'Live-Casino') {
                        let arrGame = ['hotgraph' ,'agcasino' ,'sexygaming']
                        let href = ''
                        if (arrGame.indexOf(item.ID.toLowerCase()) != -1) {
                            href = `/${item.CATEGORY}/${item.ID}?enterGame=true&gtype=${item.CATEGORY}&Gamename=${item.NAME}&GameId=${item.ID}`
                        } else {
                            href = `/${item.CATEGORY}/${item.ID.toLowerCase()}?enterGame=true&gtype=${item.CATEGORY}&Gamename=${item.NAME}&GameId=${item.ID}`
                        }
                        let resJoinGame = await this.JoinGame(href);
                        if (typeof resJoinGame == 'object' && resJoinGame.hasOwnProperty('Status')) {
                            if (resJoinGame.Status == 'SUCCESS') {
                                this.$router.push({ name: "Play Games", params: { dataGameJoin: resJoinGame.Data } });
                            }
                        }
                    }
                }
           
        },
        gotoGameList() {
            // get path current
            // console.log('MobileCategories.vue -> gotoGameList -> this.$router', this.$router)
            this.$router.push({ name: "Mobile Categories" });
        },
        getGameImageAsset(index) {
            try {
                if (index.toLowerCase().indexOf('pgsoft') != -1) index = 'PGSoft'
                else if (index.toLowerCase().indexOf('pragmatic') != -1) index = 'PragmaticPlay2'
                return require(`@/assets/images/_games/${index}.png`)
            } catch (error) {
                return ""
            }
        },
        convertImage(image) {
            let mdIconName = ""
            if (image == 'fas fa-spade') {
                mdIconName = "mdi-cards-spade"
            } else if (image == 'fas fa-club') {
                mdIconName = "mdi-cards-club"
            } else if (image == 'fas fa-dice') {
                mdIconName = "mdi-dice-6"
            } else if (image == 'fas fa-bomb') {
                mdIconName = "mdi-bomb"
            } else if (image == 'fas fa-chess') {
                mdIconName = "mdi-chess-queen"
            } else if (image == 'fas fa-rocket') {
                mdIconName = "mdi-rocket"
            } else if (image == 'fas fa-diamond') {
                mdIconName = "mdi-diamond"
            } else if (image == 'fas fa-user-robot') {
                mdIconName = "mdi-robot"
            } else if (image == 'fas fa-raygun') {
                mdIconName = "mdi-ray-gun"
            } else if (image == 'fas fa-dice-d10') {
                mdIconName = "mdi-dice-d10"
            } else if (image == 'fas fa-dice-d6') {
                mdIconName = "mdi-dice-d6"
            } else if (image == 'fas fa-snake') {
                mdIconName = "mdi-snake"
            } else if (image == 'fas fa-meteor') {
                mdIconName = "mdi-meteor"
            } else {
                mdIconName = "mdi-poker-chip"
            }
            return mdIconName
        },
        setNoImage(e, item) {
            e.target.src = require("@/assets/images/Image_not_available.png")
        },
    }
}
</script>
<style lang="scss">
.card-game-show {
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: #b1b1b1;
    border-radius: 10px;
    // margin-bottom: 10px;
    padding-top: 20px;
}

.mobile-tabs-categories {
    // height: calc(100vh - 112px);
    // position: fixed;
    // top: 56px;
    height: calc(100vh - 230px);
    // position: fixed;
    // top: 169px;

    .v-card {
        background-color: transparent !important;
    }
    .v-slide-group__wrapper {
        background-color: transparent !important;
    }
    
    .v-slide-group__content {
        display: block;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .v-tabs-items {
        height: 100%;
        overflow: scroll;
        // background-color: transparent !important;
    }

    .v-tab {
        height: 80px !important;
        width: 90px !important;

        border-bottom: 1px solid rgb(218, 225, 231);
        border-right: 1px solid rgb(218, 225, 231);
    }
}
@media screen and (min-width: 700px) {
    .mobile-tabs-categories {
        height: calc(100vh - 256px);
    }
}
.v-tab.v-tab--active {
    background: #cc9038 !important;
}
.mobile-expansion-panels {
    .v-expansion-panel-content__wrap {
        padding-right: 0;
        padding-left: 0;
    }
}

.top-categories-img {
    width: 385px;
    min-width: 100%;
    max-width: 100%;

}
.card-game-show.none-width {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: #2d2d2d;
    border-radius: 10px;
}
.card-cat-game {
    width: 70px;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #2d2d2d;
    border-radius: 10px;
}
.in-game-list .v-application--wrap {
    
}
.theme--light.v-tabs-items {
    
}

</style>
